import { combineLatest, first, switchMap, take, tap } from 'rxjs';
import { inject } from '@angular/core';

import { LanguageService } from '@spartacus/core';

import { PriceConfigService } from '@seb/web-design-system/core';

import { ConfigurationService } from '../services/configuration.service';
import { BaseStoreService } from '../services/base-store.service';

/**
 * Get WebCommonConfig and then CustomBaseStore one
 * @returns And observable
 */
export const appMainInitializer = () => {
  const configurationService = inject(ConfigurationService);
  const baseStoreService = inject(BaseStoreService);
  const priceConfigService = inject(PriceConfigService);
  const languageService = inject(LanguageService);

  return configurationService.initAppConfig().pipe(
    switchMap((config) => {
      if (!config) {
        throw new Error('ConfigurationService configPrice not loaded');
      }

      return combineLatest([
        languageService.getActive(),
        baseStoreService.initBaseStore().pipe(first((val) => !!val))
      ]).pipe(
        take(1),
        tap(([language, baseStore]) => {
          const idSite = baseStore?.uid;
          const doubleCurrency = config.doubleCurrency?.[idSite];
          const defaultCurrencyIsoCode = baseStore?.defaultCurrency?.isocode;

          priceConfigService.setConfig(
            doubleCurrency?.enabled,
            doubleCurrency?.exchange?.rate,
            defaultCurrencyIsoCode,
            language,
            doubleCurrency?.currencies
          );
        })
      );
    })
  );
};
